import React, { useState, useEffect } from 'react';
import {
  Card, Table, Button, Modal, ListGroup, Container, Row, Col,
  Form, Badge, Alert, InputGroup
} from 'react-bootstrap';

// Default staff/admin (for first use)
function AdminDashboard({ onLogout, onSwitchRole }) {








    // Get current admin info from localStorage
  const currentAdmin = JSON.parse(localStorage.getItem('admin'));
  // Message permission helpers
const canMessageStudents =
  currentAdmin?.isMaster || currentAdmin?.permissions?.messagesStudents;
const canMessageInstitutes =
  currentAdmin?.isMaster || currentAdmin?.permissions?.messagesInstitutes;

  const [showStaffModal, setShowStaffModal] = useState(false);
  const [newStaff, setNewStaff] = useState({
    name: "",
    email: "",
    password: "",
    permissions: {
      manageStudents: false,
      deleteStudent: false,
      manageInstitutes: false,
      deleteInstitute: false,
      viewApplications: false,
      deleteApplication: false,
      viewReports: false,
      messagesStudents: false,
      messagesInstitutes: false,
       deleteMessages: false,
       viewQueries: false,       // NEW
  viewAcademies: false,      // NEW
  deleteQueries: false
    }
  });



  const [editStaffIndex, setEditStaffIndex] = useState(null);
  const [showStaffDeleteModal, setShowStaffDeleteModal] = useState(false);
  const [deleteStaffIndex, setDeleteStaffIndex] = useState(null);
  const [showStaffPasswordModal, setShowStaffPasswordModal] = useState(false);
  const [staffPassword, setStaffPassword] = useState("");
  const [changePasswordIndex, setChangePasswordIndex] = useState(null);


  // Dashboard tabs
  const [tab, setTab] = useState('analytics');
  

  // Student, Institute, Applications, Messages states (from your original code)
  const [showReceiptModal, setShowReceiptModal] = useState(false);
const [previewReceipt, setPreviewReceipt] = useState(null);

  const [students, setStudents] = useState([]);
const [loadingStudents, setLoadingStudents] = useState(true);
const [studentsError, setStudentsError] = useState('');


  const [institutes, setInstitutes] = useState([]);
const [loadingInstitutes, setLoadingInstitutes] = useState(true);
const [institutesError, setInstitutesError] = useState('');

  const [applications, setApplications] = useState([]);
  const [studentSearch, setStudentSearch] = useState('');
  const [instituteSearch, setInstituteSearch] = useState('');
  const [applicationSearch, setApplicationSearch] = useState('');
  const [applicationSearchInput, setApplicationSearchInput] = useState("");
  const [dateFilter, setDateFilter] = useState({ from: '', to: '' });
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [showInstituteModal, setShowInstituteModal] = useState(false);
  const [showAppModal, setShowAppModal] = useState(false);
  const [loadingApplications, setLoadingApplications] = useState(true);
const [applicationsError, setApplicationsError] = useState('');
const [sessionFilter, setSessionFilter] = useState(""); // "" means show all


// Pagination for Applications
const [appPage, setAppPage] = useState(1);
const [appLimit] = useState(100); // page size fixed at 100
const [appsHasMore, setAppsHasMore] = useState(false);
const [appsLoadingMore, setAppsLoadingMore] = useState(false);




//Offer Accepted view in admin
const [showOfferProofModal, setShowOfferProofModal] = useState(false);
const [offerProofDoc, setOfferProofDoc] = useState(null);
const [statusFilter, setStatusFilter] = useState('');




  // Change password modal (students/institutes)
  const [showChangePassModal, setShowChangePassModal] = useState(false);
  const [passTarget, setPassTarget] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [changePassError, setChangePassError] = useState('');
  const [changePassSuccess, setChangePassSuccess] = useState('');

  // Message system
  const [adminMessages, setAdminMessages] = useState([]);
const [loadingAdminMessages, setLoadingAdminMessages] = useState(true);
const [adminMessagesError, setAdminMessagesError] = useState('');
const [msgTarget, setMsgTarget] = useState(null);
  const [msgThread, setMsgThread] = useState([]);
 const [showMsgModal, setShowMsgModal] = useState(false);
 const [messageUsers, setMessageUsers] = useState([]);
 const [unreadMap, setUnreadMap] = useState({});


  const [msgText, setMsgText] = useState('');
  const [mainAlert, setMainAlert] = useState('');
  const [msgAlert, setMsgAlert] = useState('');

//student application form in the admindashboard

const [showAppFormModal, setShowAppFormModal] = useState(false);
const [appFormData, setAppFormData] = useState(null);

//State for Modal and Referred Students
const [showReferredModal, setShowReferredModal] = useState(false);
const [referredByAcademy, setReferredByAcademy] = useState(null); // holds selected academy object
const [referredStudents, setReferredStudents] = useState([]); // holds students list


  //Query Block 


  const [queries, setQueries] = useState([]);
const [showQueriesModal, setShowQueriesModal] = useState(false);
const [queriesLoading, setQueriesLoading] = useState(false);
const [queriesError, setQueriesError] = useState('');
const [selectedQuery, setSelectedQuery] = useState(null);
const [newQueryCount, setNewQueryCount] = useState(0); // For "New" badge
const [readQueryIds, setReadQueryIds] = useState([]); // For tracking which queries have been read
const [lastQueriesFetched, setLastQueriesFetched] = useState(0);
const [queryDateFilter, setQueryDateFilter] = useState(""); // For filtering by date

//Helper for Document View.
const [hoveredDocIndex, setHoveredDocIndex] = useState(null);

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const API_BASE = isDev ? "http://localhost:5000" : "";

function getDocDownloadUrl(doc) {
  return doc?.url ? `${API_BASE}${doc.url}` : doc.data;
}

//Acadmeies/consultants
const [academies, setAcademies] = useState([]);
const [showAcademyModal, setShowAcademyModal] = useState(false);
const [newAcademy, setNewAcademy] = useState({
  name: "",
  address: "",
  city: "",
  contactPerson: "",
  phone: "",
  email: ""
});

useEffect(() => {
  if (tab === "academies") {
    const token = localStorage.getItem("authToken");
    fetch("/api/admin/academies", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setAcademies(data.academies || []));
  }
}, [tab]);

useEffect(() => {
  // Always fetch all academies on first render, for student referral lookups
  const token = localStorage.getItem("authToken");
  fetch("/api/admin/academies", {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => setAcademies(data.academies || []));
}, []);



//query useEffect
useEffect(() => {
  if (tab !== 'queries') return;

  // Only fetch if it's been more than 1 hour since last fetch
  const now = Date.now();
  if (now - lastQueriesFetched < 60 * 60 * 1000) return; // 1 hour = 3600000 ms

  setQueriesLoading(true);
  setQueriesError('');
  const token = localStorage.getItem('authToken');
  fetch('/api/admin/queries', {
    headers: { 'Authorization': `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
      setQueries(data.queries || []);
      // Find queries not in readQueryIds and count as "new"
      const unread = (data.queries || []).filter(q => !readQueryIds.includes(q._id));
      setNewQueryCount(unread.length);
      setQueriesLoading(false);
      setLastQueriesFetched(now); // update fetch time!
    })
    .catch(() => {
      setQueriesError('Could not load queries.');
      setQueriesLoading(false);
    });
}, [tab, lastQueriesFetched]); // Only these dependencies!


//query Badge reset
useEffect(() => {
  if (tab === 'queries') {
  setNewQueryCount(0);
  setReadQueryIds(queries.map(q => q._id));
}
}, [tab, queries]);




useEffect(() => {
  // Fetch all admin messages for all students and institutes (two calls)
  const token = localStorage.getItem("authToken");
  if (!token) return;
  // First get all students who have messaged admin
 fetch("/api/students", {
  headers: { Authorization: `Bearer ${token}` }
})
  .then(res => res.json())
  .then(studentsPayload => {
    const studentArr = Array.isArray(studentsPayload)
      ? studentsPayload
      : (studentsPayload.students || []);
    return Promise.all(
      studentArr.map(stud =>
          fetch(`/api/messages/admin-student/${stud.email}`, {
            headers: { Authorization: `Bearer ${token}` }
          })
            .then(res => res.json())
            .then(data => data.messages && data.messages.length > 0
              ? { type: "student", email: stud.email, name: stud.name }
              : null
            )
        )
      ).then(studentThreads => {
        // Now do the same for institutes
        fetch("/api/institutes", {
          headers: { Authorization: `Bearer ${token}` }
        })
          .then(res => res.json())
  .then(data => {
    const instArr = Array.isArray(data) ? data : (data.institutes || []);
    Promise.all(
      instArr.map(inst =>
        
                fetch(`/api/messages/admin-institute/${inst.email}`, {
                  headers: { Authorization: `Bearer ${token}` }
                })
                  .then(res => res.json())
                  .then(data => data.messages && data.messages.length > 0
                    ? { type: "institute", email: inst.email, name: inst.name }
                    : null
                  )
              )
            ).then(instituteThreads => {
              // Merge and filter nulls
           const users = [
  ...studentThreads.filter(x => x),
  ...instituteThreads.filter(x => x)
];

// Filter by staff permissions
const filteredUsers = users.filter(u =>
  (u.type === "student" && canMessageStudents) ||
  (u.type === "institute" && canMessageInstitutes)
);

setMessageUsers(filteredUsers);

// Build unread map only for allowed users
const token2 = localStorage.getItem("authToken");
if (filteredUsers.length > 0 && token2) {
  Promise.all(
    filteredUsers.map(user => {
      const endpoint =
        user.type === "student"
          ? `/api/messages/admin-student/${user.email}`
          : `/api/messages/admin-institute/${user.email}`;
      return fetch(endpoint, {
        headers: { Authorization: `Bearer ${token2}` }
      })
        .then(res => res.ok ? res.json() : { messages: [] })
        .then(data => {
          const hasUnread = (data.messages || []).some(
            m => m.to === "admin" && !m.read
          );
          return { key: user.email + ":" + user.type, hasUnread };
        })
        .catch(() => ({ key: user.email + ":" + user.type, hasUnread: false }));
    })
  ).then(results => {
    const map = {};
    results.forEach(r => { map[r.key] = r.hasUnread; });
    setUnreadMap(map);
  });
}

            });
          });
      });
    });
}, []);

//Helper For payment receipt view

function getStudentPaymentReceipt(student) {
  // Search student's documents for typeTag === 'paymentReceipt'
  if (student.documents && Array.isArray(student.documents)) {
    return student.documents.find(
      doc => doc.typeTag === 'paymentReceipt' || doc.documentType === 'paymentReceipt'
    );
  }
  return null;
}


//Handler for Submitting a New Academy

function handleAddAcademy() {
  const token = localStorage.getItem("authToken");
  fetch("/api/admin/academies", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(newAcademy)
  })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setShowAcademyModal(false);
        setNewAcademy({ name: "", address: "", city: "", contactPerson: "", phone: "", email: "" });
        setAcademies(prev => [...prev, data.academy]);
      } else {
        alert(data.message || "Could not add academy.");
      }
    })
    .catch(() => alert("Could not connect to server."));
}

//Handler to Fetch Referred Students
function handleViewReferredStudents(acad) {
  setReferredByAcademy(acad);
  const token = localStorage.getItem("authToken");
  fetch(`/api/admin/academies/${encodeURIComponent(acad.email)}/students`, {
    headers: { Authorization: `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
      setReferredStudents(data.students || []);
      setShowReferredModal(true);
    });
}



  function handleMarkPaymentReceived(email, newPaidState) {
 const confirmMsg = newPaidState
  ? "Confirm payment has been received for this student?"
  : "Are you sure you want to mark this student as NOT PAID?";
if (!window.confirm(confirmMsg)) return;

const token = localStorage.getItem('authToken'); // <-- add this line at the top

fetch('/api/admin/students/payment', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  },
  body: JSON.stringify({ email, paid: newPaidState }),
})
  .then(res => res.json())
  .then(data => {
    setMainAlert(newPaidState
      ? "Payment marked as received."
      : "Payment status reverted to NOT PAID."
    );
    // Refresh students list from backend
    fetch('/api/admin/students', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setStudents(Array.isArray(data.students) ? data.students : []));
  })
  .catch(() => setMainAlert('Could not update payment status!'));
}


  // Staff state
 const [staff, setStaff] = useState([]);
const token = localStorage.getItem('authToken');  // <-- add this line near the top

useEffect(() => {
  fetch('/api/admins', {
    headers: { 'Authorization': `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => setStaff(data))
    .catch(err => console.error("Error loading staff from backend", err));
}, []);

useEffect(() => {
  setLoadingStudents(true);
  setStudentsError('');
  fetch('/api/admin/students', {
    headers: { 'Authorization': `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
  setStudents(Array.isArray(data.students) ? data.students : []);
  setLoadingStudents(false);
})

    .catch(() => {
      setStudentsError('Could not load students from backend.');
      setLoadingStudents(false);
    });
}, []);



useEffect(() => {
  setLoadingInstitutes(true);
  setInstitutesError('');
  const token = localStorage.getItem('authToken');
  fetch('/api/admin/institutes', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => {
      setInstitutes(Array.isArray(data.institutes) ? data.institutes : []);
      setLoadingInstitutes(false);
    })
    .catch(() => {
      setInstitutesError('Could not load institutes from backend.');
      setLoadingInstitutes(false);
    });
}, []);


  // Fetch all applications

useEffect(() => {
  if (tab !== "applications") return;

  // Build query string from filters and page
  const params = new URLSearchParams();
  params.set("page", String(appPage));
  params.set("limit", String(appLimit));
  if (applicationSearch) params.set("search", applicationSearch);
  if (dateFilter.from) params.set("from", dateFilter.from);
  if (dateFilter.to) params.set("to", dateFilter.to);
  if (statusFilter) params.set("status", statusFilter);        // "pending" | "approved" | "rejected" | "accepted"
  if (sessionFilter) params.set("session", sessionFilter);     // e.g., "Spring 2025"

  const token = localStorage.getItem('authToken');

  // When page is 1, we’re doing a fresh load; when page > 1, we’re “loading more”
  const setLoading = appPage === 1 ? setLoadingApplications : setAppsLoadingMore;
  setLoading(true);
  setApplicationsError('');

  fetch(`/api/admin/applications?${params.toString()}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
      const list = Array.isArray(data.applications) ? data.applications : [];
      if (appPage === 1) {
        setApplications(list);          // fresh replace
      } else {
        setApplications(prev => [...prev, ...list]);  // append
      }
      setAppsHasMore(Boolean(data.hasMore));          // backend should send this
      setLoading(false);
    })
    .catch(() => {
      if (appPage === 1) setApplications([]);
      setApplicationsError("Could not load applications from backend.");
      setLoading(false);
    });
}, [
  tab,
  appPage,
  appLimit,
  applicationSearch,
  dateFilter.from,
  dateFilter.to,
  statusFilter,
  sessionFilter
]);





  


  // Logout function
  const handleLogout = () => {
    window.location.href = "/admin-login";
  };

  // Staff management handlers
  const handleStaffInput = (field, value) => {
    setNewStaff(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleStaffPermission = (perm) => {
    setNewStaff(prev => ({
      ...prev,
      permissions: { ...prev.permissions, [perm]: !prev.permissions[perm] }
    }));
  };

  const openAddStaff = () => {
    setEditStaffIndex(null);
    setNewStaff({
      name: "",
      email: "",
      password: "",
      permissions: {
        manageStudents: false,
        deleteStudent: false,
        manageInstitutes: false,
        deleteInstitute: false,
        viewApplications: false,
        deleteApplication: false,
        viewReports: false,
        messagesStudents: false,
        messagesInstitutes: false,
        deleteMessages: false,
        viewQueries: false,       // NEW
        viewAcademies: false,   // NEW
        deleteQueries: false
      }
    });
    setShowStaffModal(true);
  };

  const handleAddOrEditStaff = async () => {
  if (!newStaff.email || !newStaff.password) {
    setMainAlert("Email and password are required for staff.");
    return;
  }
  if (editStaffIndex !== null) {
  // EDIT EXISTING STAFF (BACKEND)
  const staffToEdit = staff[editStaffIndex];
  if (!staffToEdit || !staffToEdit.email) {
    setMainAlert("Error: Could not find staff to edit.");
    setShowStaffModal(false);
    return;
  }
  try {
   const token = localStorage.getItem('authToken');
const response = await fetch(`/api/admins/${staffToEdit.email}`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
  },
  body: JSON.stringify({
    name: newStaff.name,
    permissions: newStaff.permissions
  }),
});


    const data = await response.json();
    if (response.ok) {
      // Refetch staff from backend
     const token = localStorage.getItem('authToken');
  const staffRes = await fetch('/api/admins', {
    headers: { 'Authorization': `Bearer ${token}` }
  });
      const staffList = await staffRes.json();
      setStaff(staffList);
      setShowStaffModal(false);
      setMainAlert("Staff updated.");
    } else {
      setMainAlert(data.message || "Could not update staff.");
      setShowStaffModal(false);
    }
  } catch (err) {
    setMainAlert("Network error. Could not update staff.");
    setShowStaffModal(false);
  }
  return;
}

  try {
  const token = localStorage.getItem('authToken');  // Make sure this is near the top of your component

const response = await fetch('/api/admin/register', {
  method: 'POST',
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`         // <-- Add this line!
  },
  body: JSON.stringify({ 
    name: newStaff.name,
    email: newStaff.email,
    password: newStaff.password,
    isMaster: false, // or set via modal if you want
    permissions: newStaff.permissions
  })
});

    const data = await response.json();
    if (response.ok) {
      setStaff(prev => [...prev, data.admin]);
      setShowStaffModal(false);
      setMainAlert("New staff created.");
    } else {
      setMainAlert(data.message || "Failed to create staff.");
    }
  } catch (err) {
    setMainAlert("Network error. Try again.");
  }
};


  const openEditStaff = (idx) => {
    setEditStaffIndex(idx);
    setNewStaff({ ...staff[idx], permissions: { ...staff[idx].permissions } });
    setShowStaffModal(true);
  };

  const openDeleteStaff = (idx) => {
    setDeleteStaffIndex(idx);
    setShowStaffDeleteModal(true);
  };

  const handleDeleteStaff = async () => {
  const staffToDelete = staff[deleteStaffIndex];
  if (!staffToDelete || !staffToDelete.email) {
    setMainAlert("Error: Could not find staff to delete.");
    setShowStaffDeleteModal(false);
    return;
  }

  try {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`/api/admins/${staffToDelete.email}`, {
    method: "DELETE",
    headers: { 
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    }
    // No body needed!
  });

  const data = await response.json();
  if (response.ok) {
    // Refetch staff from backend
    const staffRes = await fetch('/api/admins', {
      headers: { "Authorization": `Bearer ${token}` }
    });
    const staffList = await staffRes.json();
    setStaff(staffList);
    setMainAlert("Staff deleted.");
  } else {
    setMainAlert(data.message || "Could not delete staff.");
  }
} catch (err) {
  setMainAlert("Network error. Could not delete staff.");
}

  setShowStaffDeleteModal(false);
};


  const openChangeStaffPassword = (idx) => {
    setChangePasswordIndex(idx);
    setStaffPassword('');
    setShowStaffPasswordModal(true);
  };

  const handleChangeStaffPassword = async () => {
  const staffToEdit = staff[changePasswordIndex];
  if (!staffToEdit || !staffToEdit.email) {
    setMainAlert("Error: Could not find staff to update password.");
    setShowStaffPasswordModal(false);
    return;
  }
  if (!staffPassword || staffPassword.length < 7) {
  setMainAlert("Password must be at least 7 characters.");
  return;
}

  try {
    const token = localStorage.getItem('authToken');
const response = await fetch(`/api/admins/${staffToEdit.email}/change-password`, {
  method: "POST",
  headers: { 
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
  },
  body: JSON.stringify({ newPassword: staffPassword })
});
const data = await response.json();
if (response.ok) {
  setMainAlert("Staff password updated.");
  // Optionally reload staff list from backend
  const staffRes = await fetch('/api/admins', {
    headers: { "Authorization": `Bearer ${token}` }
  });
  const staffList = await staffRes.json();
  setStaff(staffList);
  setShowStaffPasswordModal(false);
} else {
  setMainAlert(data.message || "Could not update password.");
}

  } catch (err) {
    setMainAlert("Network error. Could not update password.");
  }
};


  
function handleOpenMsgThread(user) {
  setMsgTarget(user);
  setMsgThread([]); // Clear
  setShowMsgModal(true);
  setMsgAlert("");
  const token = localStorage.getItem("authToken");
  if (!token) return;
  const endpoint =
    user.type === "student"
      ? `/api/messages/admin-student/${user.email}`
      : `/api/messages/admin-institute/${user.email}`;
  
  // First, mark as read, then fetch messages
  fetch("/api/messages/mark-read", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      userType: user.type,
      userEmail: user.email
    })
  }).then(() => {
    fetch(endpoint, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setMsgThread(data.messages || []));
      
    // Instantly update unreadMap so badge disappears
    setUnreadMap(prev => ({
      ...prev,
      [user.email + ":" + user.type]: false
    }));
  });
}



function handleSendAdminMsg() {
  if (!msgText.trim() || !msgTarget) return;

  const token = localStorage.getItem('authToken');
  if (!token) return;

  // Decide endpoint based on type
  const url =
    msgTarget.type === "student"
      ? "/api/messages/admin-student/send"
      : "/api/messages/admin-institute/send";

  // Decide body key based on type
  const body =
    msgTarget.type === "student"
      ? { studentEmail: msgTarget.email, text: msgText }
      : { instituteEmail: msgTarget.email, text: msgText };

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  })
    .then(res => res.json())
    .then(data => {
      if (data.msg) {
        // Update the thread locally (no need to re-fetch unless you want)
        setMsgThread(prev => [...prev, data.msg]);
        setMsgText('');
        setMsgAlert("Message sent.");
        // Optionally, clear msgAlert after 2 sec
        setTimeout(() => setMsgAlert(''), 2000);
      } else {
        setMsgAlert("Failed to send message.");
      }
    })
    .catch(() => setMsgAlert("Network error. Could not send message."));
}


function handleDeleteMsgThread(user) {
  if (!window.confirm(`Are you sure you want to delete all messages with this ${user.type}?`)) return;
  const token = localStorage.getItem("authToken");
  fetch("/api/messages/thread", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      userType: user.type,
      userEmail: user.email
    })
  })
    .then(res => res.json())
    .then(data => {
      // After deletion, refresh the messageUsers and unreadMap:
      setMessageUsers(users => users.filter(u => u.email !== user.email || u.type !== user.type));
      setUnreadMap(map => {
        const newMap = { ...map };
        delete newMap[user.email + ":" + user.type];
        return newMap;
      });
    });
}

 // Session Filter
function getSessionOptions() {
  const now = new Date();
  const year = now.getFullYear();
  const nextYear = year + 1;
  const lastYear = year - 1;
  return [
    { value: "", label: "All Sessions" },
    { value: `Spring ${lastYear}`, label: `Spring ${lastYear}` },
    { value: `Fall ${lastYear}`, label: `Fall ${lastYear}` },
    { value: `Spring ${year}`, label: `Spring ${year}` },
    { value: `Fall ${year}`, label: `Fall ${year}` },
    { value: `Spring ${nextYear}`, label: `Spring ${nextYear}` },
    { value: `Fall ${nextYear}`, label: `Fall ${nextYear}` },
  ];
}


  // FILTER APPLICATIONS BY SEARCH/FILTERS
  function filterApplications(apps) {
    let filtered = [...apps];
    if (applicationSearch) {
      filtered = filtered.filter(app =>
        (app.studentName && app.studentName.toLowerCase().includes(applicationSearch.toLowerCase())) ||
        (app.studentEmail && app.studentEmail.toLowerCase().includes(applicationSearch.toLowerCase())) ||
        (app.instituteName && app.instituteName.toLowerCase().includes(applicationSearch.toLowerCase())) ||
        (app.instituteEmail && app.instituteEmail.toLowerCase().includes(applicationSearch.toLowerCase()))
      );
    }
    if (dateFilter.from) {
      const fromDate = new Date(dateFilter.from);
      filtered = filtered.filter(app => {
        const d = new Date(app.date.split('/').reverse().join('-'));
        return d >= fromDate;
      });
    }
    if (dateFilter.to) {
      const toDate = new Date(dateFilter.to);
      filtered = filtered.filter(app => {
        const d = new Date(app.date.split('/').reverse().join('-'));
        return d <= toDate;
      });
    }

    // ---- NEW: Status filter logic ----
  if (statusFilter === "accepted") {
    filtered = filtered.filter(app =>
      app.status === "approved" && app.offerAccepted
    );
  } else if (statusFilter) {
    filtered = filtered.filter(app =>
      app.status === statusFilter
    );
  }
   
  if (sessionFilter) {
    filtered = filtered.filter(app => app.session === sessionFilter);
  }
  return filtered;
}


  // CHANGE PASSWORD (students/institutes)
  function openChangePass(type, email) {
  setPassTarget({ type, email });
  setNewPassword('');
  setChangePassError('');
  setChangePassSuccess('');
  setShowChangePassModal(true);
}

function handleChangePassword() {
  const token = localStorage.getItem('authToken');
  if (newPassword.length < 4) {
    setChangePassError('Password must be at least 4 characters.');
    setChangePassSuccess('');
    return;
  }
  setChangePassError('');
  if (passTarget.type === 'student') {
    fetch('/api/admin/students/reset-password', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ email: passTarget.email, newPassword })
    })
      .then(res => res.json())
      .then(data => {
        setChangePassSuccess('Password changed successfully.');
        // Refresh students from backend
        fetch('/api/admin/students', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
          .then(res => res.json())
          .then(data => setStudents(Array.isArray(data.students) ? data.students : []));
        setTimeout(() => setShowChangePassModal(false), 1200);
      })
      .catch(() => setChangePassError('Could not update password!'));
  }
  else if (passTarget.type === 'institute') {
    fetch('/api/admin/institutes/reset-password', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ email: passTarget.email, newPassword })
    })
      .then(res => res.json())
      .then(data => {
        setChangePassSuccess('Password changed successfully.');
        // Refresh institutes from backend (add code if you want to refresh the list)
        setTimeout(() => setShowChangePassModal(false), 1200);
      })
      .catch(() => setChangePassError('Could not update password!'));
  }
}


  // DELETE STUDENT/INSTITUTE/APPLICATION
 function handleDelete(type, email) {
  if (!window.confirm(`Are you sure you want to delete this ${type}? This cannot be undone.`)) return;
  const token = localStorage.getItem('authToken');

  if (type === 'student') {
    fetch(`/api/admin/students/${email}`, {
      method: 'DELETE',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
      // No body needed for DELETE now!
    })
      .then(res => res.json())
      .then(data => {
        setMainAlert('Student deleted, including all associated data and files.');
        // Re-fetch students from backend after deletion (best practice)
        fetch('/api/admin/students', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(res => res.json())
.then(data => setStudents(Array.isArray(data.students) ? data.students : []));

      })
      .catch(() => setMainAlert('Could not delete student!'));
  }

  else if (type === 'institute') {
    fetch(`/api/admin/institutes/${email}`, {
      method: 'DELETE',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
      // No body needed for DELETE now!
    })
      .then(res => res.json())
      .then(data => {
        setMainAlert('Institute deleted.');
        // Re-fetch institutes from backend after deletion
        fetch('/api/admin/institutes', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
          .then(res => res.json())
          .then(data => setInstitutes(Array.isArray(data.institutes) ? data.institutes : []));
      })
      .catch(() => setMainAlert('Could not delete institute!'));
  }
}


 function handleUndoApplicationStatus(idx) {
  const app = applications[idx];
  const token = localStorage.getItem('authToken');
  fetch('/api/admin/update-application-status', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      studentEmail: app.studentEmail,
      course: app.course,
      status: 'pending'
    }),
  })
    .then(res => res.json())
    .then(data => {
      setMainAlert('Application status reverted to pending.');
      // Refresh applications from backend after status change
      fetch('/api/admin/applications', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
       .then(res => res.json())
.then(data => setApplications(Array.isArray(data.applications) ? data.applications : []));
    })
    .catch(() => setMainAlert('Could not update application status!'));
}



 function handleDeleteApplication(appIdx) {
  if (!window.confirm("Are you sure you want to delete this application?")) return;
  const app = applications[appIdx];
  const token = localStorage.getItem('authToken');
  fetch(`/api/admin/applications/${app._id}`, {
    method: 'DELETE',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => {
      setMainAlert('Application deleted.');
      // Refresh applications from backend after deletion
      fetch('/api/admin/applications', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(res => res.json())
  .then(data => setApplications(Array.isArray(data.applications) ? data.applications : []));
    })
    .catch(() => setMainAlert('Could not delete application!'));
}

// Helper: Filter queries by date
function getFilteredQueries() {
  if (!queryDateFilter) return queries;
  return queries.filter(q => {
    if (!q.date) return false;
    const qDate = new Date(q.date);
    const filterDate = new Date(queryDateFilter + "T00:00:00");
    return (
      qDate.getFullYear() === filterDate.getFullYear() &&
      qDate.getMonth() === filterDate.getMonth() &&
      qDate.getDate() === filterDate.getDate()
    );
  });
}

// Quereies Export csv
function exportQueriesToCSV() {
  const filtered = getFilteredQueries();
  if (filtered.length === 0) {
    alert("No queries to export for the selected date.");
    return;
  }
  const headers = [
    "Query ID", "Date", "Student Name", "Student Email", "Student Phone",
    "Institute/University", "Course", "Message"
  ];
  const rows = filtered.map(q => [
    q._id || "",
    q.date ? new Date(q.date).toLocaleString() : "",
    q.studentName || "",
    q.studentEmail || "",
    q.studentPhone || "",
    q.universityName || q.instituteName || "",
    q.courseName || "",
    q.message || ""
  ]);
  const csvContent = [
    headers.join(","),
    ...rows.map(row => row.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))
  ].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `queries_${queryDateFilter || "all"}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// exportcsv applications

function exportFilteredApplicationsToCSV() {
  const filtered = filterApplications(applications); // uses your current filters!
  if (!filtered.length) {
    alert("No applications to export for current filter.");
    return;
  }

  const headers = [
    "Application ID", "Date", "Student Name", "Student Email", "Student Phone",
    "Institute/University", "Course", "Status", "Offer Accepted", "Proof Document"
  ];

  const rows = filtered.map(app => [
    app._id || "",
    app.date || "",
    app.studentName || "",
    app.studentEmail || "",
    app.studentPhone || "",
    app.instituteName || "",
    app.course || "",
    app.status || "",
    app.offerAccepted ? "Yes" : "No",
    app.offerAcceptanceDoc && app.offerAcceptanceDoc.url ? (app.offerAcceptanceDoc.url.startsWith("/uploads") ? (window.location.origin + app.offerAcceptanceDoc.url) : app.offerAcceptanceDoc.url) : ""
  ]);

  const csvContent = [
    headers.join(","),
    ...rows.map(row => row.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `applications_${statusFilter || "all"}_${new Date().toISOString().slice(0,10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}



  // DYNAMIC COLORS
  const sectionCard = (title, children) => (
    <Card className="shadow mb-4">
      <Card.Header as="h4">{title}</Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card>
  );

  // MAIN RENDER
  // ---- UI starts here ----
if (tab === 'students') {
  if (loadingStudents) return <div>Loading students...</div>;
  if (studentsError) return <div style={{ color: 'red' }}>{studentsError}</div>;
}
if (tab === 'institutes') {
  if (loadingInstitutes) return <div>Loading institutes...</div>;
  if (institutesError) return <div style={{ color: 'red' }}>{institutesError}</div>;
}

if (tab === 'applications' && loadingApplications) return <div>Loading applications...</div>;
      if (tab === 'applications' && applicationsError) return <div style={{ color: 'red' }}>{applicationsError}</div>;


  return (
    <Container fluid className="mt-5" style={{ maxWidth: 1600 }}>

      {/* Top Bar */}
      <div style={{ textAlign: 'right', marginBottom: 10 }}>
        <Button variant="link" onClick={onSwitchRole} className="me-2">
          Switch Role
        </Button>
        <Button variant="outline-danger" onClick={onLogout}>
  Logout
</Button>

      </div>

      <Card className="mb-4 shadow">
        <Card.Body>
          <Row>
            <Col xs={6} md={3}>
              <h5>
                <Badge bg="info" className="me-2">{students.length}</Badge>
                Students
              </h5>
            </Col>
            <Col xs={6} md={3}>
              <h5>
                <Badge bg="secondary" className="me-2">{institutes.length}</Badge>
                Institutes
              </h5>
            </Col>
            <Col xs={6} md={3}>
              <h5>
                <Badge bg="success" className="me-2">{applications.length}</Badge>
                Applications
              </h5>
            </Col>
            <Col xs={6} md={3}>
              <h5>
                <Badge bg="dark" className="me-2">{staff.length}</Badge>
                Staff
              </h5>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Tabs */}
      <div className="mb-3 text-center">
          {(currentAdmin?.isMaster || currentAdmin?.permissions?.manageStudents) && (
   <Button
  style={{
    backgroundColor: tab === 'students' ? "#007bff" : "#fff",
    color: tab === 'students' ? "#fff" : "#007bff",
    border: "1px solid #052547ff"
  }}
  className="me-2"
  onClick={() => setTab('students')}
>
  Students
</Button>
  )}

     {(currentAdmin?.isMaster || currentAdmin?.permissions?.manageInstitutes) && (
    <Button
  style={{
    backgroundColor: tab === 'institutes' ? "#43a047" : "#fff",
    color: tab === 'institutes' ? "#fff" : "#43a047",
    border: "1px solid #43a047"
  }}
  className="me-2"
  onClick={() => setTab('institutes')}
>
  Institutes
</Button>
  )}

          {(currentAdmin?.isMaster || currentAdmin?.permissions?.viewApplications) && (
  <Button
  style={{
    backgroundColor: tab === 'applications' ? "#1d17d4ff" : "#fff",
    color: tab === 'applications' ? "#fff" : "#1522d8ff",
    border: "1px solid #1411c9ff"
  }}
  className="me-2"
  onClick={() => setTab('applications')}
>
  Applications
</Button>
  )}

        {currentAdmin?.isMaster && (
  <Button
  style={{
    backgroundColor: tab === 'staff' ? "#d11313ff" : "#fff", // Teal when active, white otherwise
    color: tab === 'staff' ? "#fff" : "#ae0f0fff",
    border: "1px solid #c30f0fff"
  }}
  className="me-2"
  onClick={() => setTab('staff')}
>
  Manage Staff
</Button>

)}


  <Button
  style={{
    backgroundColor: tab === 'messages' ? "#3f51b5" : "#fff", // Indigo active, white otherwise
    color: tab === 'messages' ? "#fff" : "#3f51b5",
    border: "1px solid #3f51b5"
  }}
  className="me-2"
  onClick={() => setTab('messages')}
>
  Messages
</Button>


{(currentAdmin?.isMaster || currentAdmin?.permissions?.viewQueries) && (
  <Button
    style={{
      backgroundColor: tab === 'queries' ? "#1d17d4ff" : "#fff",
      color: tab === 'queries' ? "#fff" : "#1522d8ff",
      border: "1px solid #1411c9ff"
    }}
    className="me-2"
    onClick={() => setTab('queries')}
  >
    Queries
  </Button>
)}

{(currentAdmin?.isMaster || currentAdmin?.permissions?.viewAcademies) && (
  <Button
    style={{
      backgroundColor: tab === 'academies' ? "#1d17d4ff" : "#fff",
      color: tab === 'academies' ? "#fff" : "#1522d8ff",
      border: "1px solid #1411c9ff"
    }}
    className="me-2"
    onClick={() => setTab('academies')}
  >
    Academies/Consultants
  </Button>
)}



      </div>

      {mainAlert && <Alert variant="info" onClose={() => setMainAlert('')} dismissible>{mainAlert}</Alert>}

      {/* Staff Management Tab */}
      {tab === 'staff' && (
        <Card className="shadow mb-4">
          <Card.Header as="h4">Staff Management</Card.Header>
          <Card.Body>
            <Button variant="success" className="mb-3" onClick={openAddStaff}>
              Add New Staff
            </Button>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Permissions</th>
                  <th>Edit</th>
                  <th>Change Password</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {staff.map((s, idx) => (
                  <tr key={idx}>
                    <td>{s.name}</td>
                    <td>{s.email}</td>
                    <td>
                      <ul style={{ marginBottom: 0 }}>
                        {Object.entries(s.permissions).map(([k, v]) =>
                          v ? <li key={k} style={{ fontSize: 12 }}>{k.replace(/([A-Z])/g, " $1")}</li> : null
                        )}
                      </ul>
                    </td>
                    <td>
                      <Button size="sm" variant="info" onClick={() => openEditStaff(idx)}>
                        Edit
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" variant="warning" onClick={() => openChangeStaffPassword(idx)}>
                        Change Password
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" variant="danger" onClick={() => openDeleteStaff(idx)}>
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}

      {/* Staff Create/Edit Modal */}
      <Modal show={showStaffModal} onHide={() => setShowStaffModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editStaffIndex !== null ? "Edit Staff" : "Add New Staff"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Name (optional)</Form.Label>
              <Form.Control
                type="text"
                value={newStaff.name}
                onChange={e => handleStaffInput("name", e.target.value)}
                placeholder="Staff Name"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={newStaff.email}
                onChange={e => handleStaffInput("email", e.target.value)}
                placeholder="Staff Email"
                required
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={newStaff.password}
                onChange={e => handleStaffInput("password", e.target.value)}
                placeholder="Password"
                required
                minLength={4}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Permissions</Form.Label>
              <div>
                <Form.Check
                  type="checkbox"
                  label="Manage Students"
                  checked={newStaff.permissions.manageStudents}
                  onChange={() => handleStaffPermission("manageStudents")}
                />
                <Form.Check
                  type="checkbox"
                  label="Delete Students"
                  checked={newStaff.permissions.deleteStudent}
                  onChange={() => handleStaffPermission("deleteStudent")}
                />
                <Form.Check
                  type="checkbox"
                  label="Manage Institutes"
                  checked={newStaff.permissions.manageInstitutes}
                  onChange={() => handleStaffPermission("manageInstitutes")}
                />
                <Form.Check
                  type="checkbox"
                  label="Delete Institutes"
                  checked={newStaff.permissions.deleteInstitute}
                  onChange={() => handleStaffPermission("deleteInstitute")}
                />
                <Form.Check
                  type="checkbox"
                  label="View Applications"
                  checked={newStaff.permissions.viewApplications}
                  onChange={() => handleStaffPermission("viewApplications")}
                />
                <Form.Check
                  type="checkbox"
                  label="Delete Applications"
                  checked={newStaff.permissions.deleteApplication}
                  onChange={() => handleStaffPermission("deleteApplication")}
                />
                <Form.Check
                  type="checkbox"
                  label="View Reports"
                  checked={newStaff.permissions.viewReports}
                  onChange={() => handleStaffPermission("viewReports")}
                />
                <Form.Check
                  type="checkbox"
                  label="Message Students"
                  checked={newStaff.permissions.messagesStudents}
                  onChange={() => handleStaffPermission("messagesStudents")}
                />
                <Form.Check
                  type="checkbox"
                  label="Message Institutes"
                  checked={newStaff.permissions.messagesInstitutes}
                  onChange={() => handleStaffPermission("messagesInstitutes")}
                />
                <Form.Check
                  type="checkbox"
                  label="Delete Messages"
                  checked={newStaff.permissions.deleteMessages}
                  onChange={() => handleStaffPermission("deleteMessages")}
                  />
                <Form.Check
                type="checkbox"

                 label="View Queries"
                 checked={newStaff.permissions.viewQueries}
                onChange={() => handleStaffPermission('viewQueries')}
                />

                <Form.Check
                type="checkbox"
                label="View Academies/Consultants"
                checked={newStaff.permissions.viewAcademies}
                onChange={() => handleStaffPermission('viewAcademies')}
                />
                <Form.Check
                  type="checkbox"
                  label="Delete Queries"
                  checked={newStaff.permissions.deleteQueries}
                  onChange={() => handleStaffPermission("deleteQueries")}
                />


              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStaffModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleAddOrEditStaff}>
            {editStaffIndex !== null ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Staff Delete Modal */}
      <Modal show={showStaffDeleteModal} onHide={() => setShowStaffDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this staff member? This cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStaffDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDeleteStaff}>Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* Staff Change Password Modal */}
      <Modal show={showStaffPasswordModal} onHide={() => setShowStaffPasswordModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Staff Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              value={staffPassword}
              onChange={e => setStaffPassword(e.target.value)}
              placeholder="New Password"
              minLength={7}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStaffPasswordModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleChangeStaffPassword}>Change</Button>
        </Modal.Footer>
      </Modal>

      {/* --- ORIGINAL DASHBOARD TABS --- */}
      {/* STUDENTS TABLE */}
      {tab === 'students' && sectionCard(
        "All Students",
        <>
       

          <Form.Control
            className="mb-2"
            style={{ maxWidth: 300, marginLeft: "auto", marginRight: 0 }}
            size="sm"
            type="text"
            placeholder="Filter by name or email..."
            value={studentSearch}
            onChange={e => setStudentSearch(e.target.value)}
          />
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Applications</th>
                <th>Profile</th>
                <th>Message</th>
                <th>Change Password</th>
                <th>Delete</th>
                <th>Payment</th> {/* NEW COLUMN */}
              </tr>
            </thead>
            <tbody>
              {students.filter(
                s => !studentSearch ||
                  s.name.toLowerCase().includes(studentSearch.toLowerCase()) ||
                  s.email.toLowerCase().includes(studentSearch.toLowerCase())
              ).map((stud, idx) => (
                <tr key={idx}>
                  <td>{stud.name}</td>
                  <td>{stud.email}</td>
                  <td>{stud.phone}</td>
                 <td>
  {applications.filter(app => app.studentEmail === stud.email).length}
</td>

                  <td>
                    <Button
                      size="sm" variant="info"
                      onClick={() => { setSelectedStudent(stud); setShowStudentModal(true); }}
                    >
                      View
                    </Button>
                  </td>
                  <td>

{currentAdmin?.isMaster || currentAdmin?.permissions?.messagesStudents ? (
  <Button
    size="sm"
    variant="info"
    onClick={() => {
      handleOpenMsgThread({
        type: "student",
        email: stud.email,
        name: stud.name
      });
    }}
  >
    Message
    {unreadMap[stud.email + ":student"] && (
    <Badge bg="danger" className="ms-2">New</Badge>
  )}
  </Button>
   ) : (
      <Button
        size="sm"
        variant="info"
        disabled
        title="No permission"
      >
        Message
      </Button>
    )}
</td>
                  <td>
                    <Button size="sm" variant="warning" onClick={() => openChangePass('student', stud.email)}>
                      Change Password
                    </Button>
                  </td>
                  <td>
  {(currentAdmin?.isMaster || currentAdmin?.permissions?.deleteStudent) ? (
    <Button
      size="sm"
      variant="danger"
      onClick={() => handleDelete('student', stud.email)}
    >
      Delete
    </Button>
  ) : (
    <Button
      size="sm"
      variant="danger"
      disabled
      title="No permission"
    >
      Delete
    </Button>
  )}
</td>

    <td>
  {stud.paid ? (
    <span>
      <Badge bg="success" className="me-2">Paid</Badge>
      <Button
        size="sm"
        variant="outline-danger"
        onClick={() => handleMarkPaymentReceived(stud.email, false)}
        style={{ fontSize: 12, padding: "1px 8px", verticalAlign: "middle" }}
      >
        Undo
      </Button>
    </span>
  ) : (
    <>
      <Button
        size="sm"
        variant="outline-primary"
        onClick={() => handleMarkPaymentReceived(stud.email, true)}
        style={{ fontWeight: 500, marginRight: 6 }}
      >
        Mark as Paid
      </Button>
      {/* Show a green "Receipt" link if there is a payment receipt */}
      {getStudentPaymentReceipt(stud) && (
        <Button
          size="sm"
          variant="link"
          style={{ color: "#128b30", padding: 0, textDecoration: "underline", fontWeight: 700 }}
          onClick={() => {
            setPreviewReceipt(getStudentPaymentReceipt(stud));
            setShowReceiptModal(true);
          }}
        >
          Receipt
        </Button>
      )}
    </>
  )}
</td>



                </tr>
              ))}
              {students.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-center text-muted">No students match your filter.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}

      {/* INSTITUTES TABLE */}
      
      {tab === 'institutes' && sectionCard(
        "All Institutes",
        <>
        
          <Form.Control
            className="mb-2"
            style={{ maxWidth: 300, marginLeft: "auto", marginRight: 0 }}
            size="sm"
            type="text"
            placeholder="Filter by name or email..."
            value={instituteSearch}
            onChange={e => setInstituteSearch(e.target.value)}
          />
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Departments</th>
                <th>Courses</th>
                <th>Profile</th>
                <th>Message</th>
                <th>Change Password</th>
                <th>Delete</th>
                <th>Queries</th>

              </tr>
            </thead>
            <tbody>
              {institutes.filter(
                i => !instituteSearch ||
                  i.name.toLowerCase().includes(instituteSearch.toLowerCase()) ||
                  i.email.toLowerCase().includes(instituteSearch.toLowerCase())
              ).map((inst, idx) => {
                const deptCount = (inst.departments || []).length;
                const courseCount = (inst.departments || []).reduce((sum, d) => sum + (d.courses?.length || 0), 0);
                return (
                  <tr key={idx}>
                    <td>{inst.name}</td>
                    <td>{inst.email}</td>
                    <td>{deptCount}</td>
                    <td>{courseCount}</td>
                    <td>
                      <Button
                        size="sm" variant="info"
                        onClick={() => { setSelectedInstitute(inst); setShowInstituteModal(true); }}
                      >
                        View
                      </Button>
                    </td>
                   <td>

 {currentAdmin?.isMaster || currentAdmin?.permissions?.messagesInstitutes ? (
  <Button
    size="sm"
    variant="info"
    onClick={() => {
      handleOpenMsgThread({
        type: "institute",
        email: inst.email,
        name: inst.name
      });
    }}
  >
    Message
    {unreadMap[inst.email + ":institute"] && (
    <Badge bg="danger" className="ms-2">New</Badge>
  )}
  </Button>
  ) : (
      <Button
        size="sm"
        variant="info"
        disabled
        title="No permission"
      >
        Message
      </Button>
    )}

</td>


                    <td>
                      <Button size="sm" variant="warning" onClick={() => openChangePass('institute', inst.email)}>
                        Change Password
                      </Button>
                    </td>
                   <td>
  {(currentAdmin?.isMaster || currentAdmin?.permissions?.deleteInstitute) ? (
    <Button
      size="sm"
      variant="danger"
      onClick={() => handleDelete('institute', inst.email)}
    >
      Delete
    </Button>
  ) : (
    <Button
      size="sm"
      variant="danger"
      disabled
      title="No permission"
    >
      Delete
    </Button>
  )}
</td>
<td>
    <Button
      size="sm"
      variant={inst.queriesAllowed ? "success" : "outline-danger"}
     onClick={async () => {
  const token = localStorage.getItem('authToken');
  const allowed = !inst.queriesAllowed;
  await fetch('/api/admin/institute/set-queries-allowed', {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      instituteId: inst._id,
      allowed
    })
  });
  // Update just this institute in the table, no reload
  setInstitutes(prev =>
    prev.map(i => i._id === inst._id ? { ...i, queriesAllowed: allowed } : i)
  );
}}

      title={inst.queriesAllowed ? "Click to block queries for this institute" : "Click to allow queries for this institute"}
    >
      {inst.queriesAllowed ? "Receiving" : "Blocked"}
    </Button>
  </td>

                  </tr>
                );
              })}
              {institutes.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-center text-muted">No institutes match your filter.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}

     
     
      {/* APPLICATIONS TABLE */}

      
      {tab === 'applications' && sectionCard(
        "All Applications",
        <>
        <Row className="g-2 align-items-end flex-nowrap" style={{ marginBottom: 0 }}>
  {/* Export to CSV Button */}
  <Col xs="auto">
    <Button
      variant="outline-success"
      size="sm"
      onClick={exportFilteredApplicationsToCSV}
    >
      Export to CSV
    </Button>
  </Col>
 {/* Search */}
<Col xs={5} md={4} lg={3}>
  <InputGroup>
    <Form.Control
      type="text"
      placeholder="Search applications..."
      value={applicationSearchInput}
      onChange={e => setApplicationSearchInput(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          setApplicationSearch(applicationSearchInput);
          setAppPage(1);
        }
      }}
    />
    <Button
      size="sm"
      variant="primary"
      onClick={() => {
        setApplicationSearch(applicationSearchInput);
        setAppPage(1);
      }}
    >
      Search
    </Button>
  </InputGroup>
</Col>

  {/* Date From */}
  <Col xs={6} md="auto" style={{ maxWidth: 170 }}>
    <Form.Control
  size="md"
  type="date"
  value={dateFilter.from}
  onChange={e => setDateFilter(df => ({ ...df, from: e.target.value }))} // fires once when a date is picked
  onBlur={() => setAppPage(1)}           // reset to page 1 after user finishes
  placeholder="From"
  inputMode="none"                        // hide mobile keyboard
  onKeyDown={e => {
    // allow navigation keys only; block typed characters
    const allowed = ['Tab','Shift','ArrowLeft','ArrowRight','Home','End','Escape'];
    if (allowed.includes(e.key)) return;
    if (e.key.length === 1) e.preventDefault(); // block character input
  }}
  onPaste={e => e.preventDefault()}       // block paste
  onDrop={e => e.preventDefault()}        // block drag-drop text
/>

  </Col>
  {/* Date To */}
  <Col xs={6} md="auto" style={{ maxWidth: 170 }}>
    <Form.Control
  size="md"
  type="date"
  value={dateFilter.to}
  onChange={e => setDateFilter(df => ({ ...df, to: e.target.value }))}   // fires once when picked
  onBlur={() => setAppPage(1)}           // reset after user finishes
  placeholder="To"
  inputMode="none"
  onKeyDown={e => {
    const allowed = ['Tab','Shift','ArrowLeft','ArrowRight','Home','End','Escape'];
    if (allowed.includes(e.key)) return;
    if (e.key.length === 1) e.preventDefault();
  }}
  onPaste={e => e.preventDefault()}
  onDrop={e => e.preventDefault()}
/>

  </Col>
  {/* Status */}
  <Col xs={6} md="auto" style={{ maxWidth: 170 }}>
    <Form.Select
      size="md"
      value={statusFilter}
      onChange={e => { setStatusFilter(e.target.value); setAppPage(1); }}
    >
      <option value="">All Statuses</option>
      <option value="pending">Pending</option>
      <option value="approved">Approved</option>
      <option value="rejected">Rejected</option>
      <option value="accepted">Accepted</option>
    </Form.Select>
  </Col>
  {/* Session */}
  <Col xs={6} md="auto" style={{ maxWidth: 1700 }}>
    <Form.Select
      size="md"
      value={sessionFilter}
      onChange={e => { setSessionFilter(e.target.value); setAppPage(1); }}
    >
      {getSessionOptions().map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </Form.Select>
  </Col>
</Row>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Student</th>
                <th>Student Email</th>
                <th>Institute</th>
                <th>Session</th>
                <th>Course</th>
                <th>Department</th>
                <th>Date</th>
                <th>Status</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app, idx) => (
                  <tr key={idx}>
                  <td>{app.studentName}</td>
                  <td>{app.studentEmail}</td>
                  <td>{app.instituteName}</td>
                  <td>{app?.session || '-'}</td>
                  <td>{app.course}</td>
                  <td>{app.department}</td>
                  <td>{app.date} </td>
                  <td>
  {app.status === "approved" ? (
    <>
      <div>approved</div>
      {app.offerAccepted && app.offerAcceptanceDoc && app.offerAcceptanceDoc.url && (
        <div style={{ fontSize: 13 }}>
          <Button
            size="sm"
            variant="link"
            style={{ color: "#128b30", padding: 0, textDecoration: "underline", fontWeight: 700 }}
            onClick={() => {
              setOfferProofDoc(app.offerAcceptanceDoc);
              setShowOfferProofModal(true);
            }}
          >
            Accepted
          </Button>
        </div>
      )}
    </>
  ) : (
    <>{app.status}</>
  )}
</td>

                  <td>
                    {currentAdmin?.permissions?.deleteApplication && app.status !== "pending" && (
    <Button
      size="sm"
      variant="warning"
      className="ms-2"
      onClick={() => handleUndoApplicationStatus(idx)}
      title="Revert status to pending"
    >
      Undo to Pending
    </Button>
  )}
  {(currentAdmin?.isMaster || currentAdmin?.permissions?.deleteApplication) ? (
  <Button
    size="sm"
    variant="danger"
    onClick={() => handleDeleteApplication(idx)}
  >
    Delete
  </Button>
) : (
  <Button
    size="sm"
    variant="danger"
    disabled
    title="No permission"
  >
    Delete
  </Button>
)}

</td>

                </tr>
              ))}
              {applications.length === 0 && (
                <tr>
                  <td colSpan={9} className="text-center text-muted">No applications match your filter.</td>
                </tr>
              )}
            </tbody>
          </Table>
{/* Load more */}
<div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
  {appsHasMore ? (
    <Button
      variant="outline-primary"
      size="sm"
      disabled={appsLoadingMore}
      onClick={() => setAppPage(p => p + 1)}
    >
      {appsLoadingMore ? "Loading..." : "Load more"}
    </Button>
  ) : (
    applications.length > 0 && <div className="text-muted">No more applications.</div>
  )}
</div>


        </>
      )}

      {/* MESSAGES TABLE */}
      {tab === 'messages' && sectionCard(
        "Messages",
        <>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>From</th>
                <th>Type</th>
                <th>Email</th>
                <th>Latest</th>
                <th>Open</th>
                <th>Delete</th>
              </tr>
            </thead>
          <tbody>
  {messageUsers.map((user, idx) => {
    // Instead of React.useState/Effect, use unreadMap (already in state)
    const badgeKey = user.email + ":" + user.type;
    const hasUnread = !!unreadMap[badgeKey];

    return (
      <tr key={user.email + user.type}>
        <td>{user.name}</td>
        <td>{user.type}</td>
        <td>{user.email}</td>
          <td>
          {/* For now, just show "—" or you can add last message text/time here */}
          —
        </td>
        <td>
          <Button
            size="sm"
            onClick={() => handleOpenMsgThread(user)}
          >
            Open
            {hasUnread && (
              <Badge bg="danger" className="ms-2">
                New
              </Badge>
            )}
          </Button>
        </td>
        
      <td>
  {currentAdmin?.isMaster || currentAdmin?.permissions?.deleteMessages ? (
    <Button
      size="sm"
      variant="danger"
      onClick={() => handleDeleteMsgThread(user)}
    >
      Delete
    </Button>
  ) : (
    <Button
      size="sm"
      variant="danger"
      disabled
      title="No permission"
    >
      Delete
    </Button>
  )}
</td>


      </tr>
    );
  })}
  {messageUsers.length === 0 && (
    <tr>
      <td colSpan={7} className="text-center text-muted">
        No messages yet.
      </td>
    </tr>
  )}
</tbody>
          </Table>
        </>
      )}


{tab === "academies" && sectionCard(
  "Academies / Consultants",
  <>
    <Button
      variant="success"
      style={{ marginBottom: 10 }}
      onClick={() => setShowAcademyModal(true)}
    >
      Add Academy/Consultant
    </Button>
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>Name</th>
          <th>Address</th>
          <th>City</th>
          <th>Contact Person</th>
          <th>Phone</th>
          <th>Email</th>
           <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {academies.length > 0 ? (
          academies.map((acad, idx) => (
            <tr key={idx}>
              <td>{acad.name}</td>
              <td>{acad.address}</td>
              <td>{acad.city}</td>
              <td>{acad.contactPerson}</td>
              <td>{acad.phone}</td>
              <td>{acad.email}</td>
              <td>
          <Button
            variant="info"
            size="sm"
            onClick={() => handleViewReferredStudents(acad)}
          >
            View Students
          </Button>
        </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={6} className="text-center text-muted">No academies/consultants yet.</td>
          </tr>
        )}
      </tbody>
    </Table>
  </>
)}



      {/* =============== MODALS =============== */}
      {/* Student Profile Modal */}
      <Modal show={showStudentModal} onHide={() => setShowStudentModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Student Profile  {selectedStudent && (
  <Button
    variant="info"
    style={{ marginLeft: 8 }}
    onClick={async () => {
      setAppFormData(null); // reset
      setShowAppFormModal(true);
      try {
        const token = localStorage.getItem('authToken');
        console.log(selectedStudent.email)
        const res = await fetch(`/api/admin/student-application-form/${selectedStudent.email}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          setAppFormData(data);
        } else {
          setAppFormData({ error: "No application form found." });
        }
      } catch {
        setAppFormData({ error: "Failed to load application form." });
      }
    }}
  >
    Application Form
  </Button>
)}
    </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedStudent && (
            <>
              <ListGroup>
                <ListGroup.Item><b>Name:</b> {selectedStudent.name}</ListGroup.Item>
                <ListGroup.Item><b>Email:</b> {selectedStudent.email}</ListGroup.Item>
                <ListGroup.Item><b>Phone:</b> {selectedStudent.phone}</ListGroup.Item>
                {selectedStudent.address && <ListGroup.Item><b>Address:</b> {selectedStudent.address}</ListGroup.Item>}
                {selectedStudent.dob && <ListGroup.Item><b>DOB:</b> {selectedStudent.dob}</ListGroup.Item>}
                {selectedStudent.gender && <ListGroup.Item><b>Gender:</b> {selectedStudent.gender}</ListGroup.Item>}
                {selectedStudent.nationality && <ListGroup.Item><b>Nationality:</b> {selectedStudent.nationality}</ListGroup.Item>}
                {selectedStudent?.referredBy && (
  <ListGroup.Item>
    <b>Referred By:</b>{" "}
    {
      // Show the academy/consultant's name, or fallback to the email if name is missing
      academies.find(a => a.email === selectedStudent.referredBy)?.name ||
      selectedStudent.referredBy
    }
  </ListGroup.Item>
)}

               <ListGroup.Item>
  <b>Uploaded Documents:</b>
  {selectedStudent.documents && selectedStudent.documents.length > 0
    ? (
      <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
        {selectedStudent.documents.map((doc, i) => (
          <li key={i} style={{ marginBottom: 16, position: "relative" }}>
            <a
              href={getDocDownloadUrl(doc)}
              download={doc.name}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", fontWeight: 600 }}
              onMouseEnter={() => setHoveredDocIndex(i)}
              onMouseLeave={() => setHoveredDocIndex(null)}
            >
              {doc.name}
            </a>
            {/* Preview only on hover */}
            {hoveredDocIndex === i && (
              <div
                style={{
                  position: "absolute",
                  left: 160,
                  top: 0,
                  zIndex: 10,
                  background: "#fff",
                  border: "1px solid #eee",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  padding: 8,
                  minWidth: 120,
                  minHeight: 120,
                  maxWidth: 200,
                  maxHeight: 200,
                }}
              >
                {doc.type && doc.type.startsWith("image/") ? (
                  <img
                    src={getDocDownloadUrl(doc)}
                    alt="Preview"
                    style={{ width: "100%", maxHeight: 180, borderRadius: 6 }}
                  />
                ) : doc.type === "application/pdf" ? (
                  <embed
                    src={getDocDownloadUrl(doc)}
                    type="application/pdf"
                    width="180px"
                    height="180px"
                    style={{ borderRadius: 6 }}
                  />
                ) : (
                  <span className="text-muted">No preview available</span>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    )
    : <span className="text-muted"> No documents uploaded.</span>
  }
</ListGroup.Item>

                
              </ListGroup>
              <hr />
              <h5>Applications:</h5>
<Table striped bordered hover size="sm">
  <thead>
    <tr>
      <th>Institute</th>
      <th>Department</th>
      <th>Course</th>
      <th>Date</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    {applications.filter(app => app.studentEmail === selectedStudent.email).map((app, i) => (
      <tr key={i}>
        <td>{app.instituteName}</td>
        <td>{app.department}</td>
        <td>{app.course}</td>
        <td>{app.date}</td>
        <td>{app.status}</td>
      </tr>
    ))}
    {applications.filter(app => app.studentEmail === selectedStudent.email).length === 0 &&
      <tr><td colSpan={5} className="text-center text-muted">No applications</td></tr>
    }
  </tbody>
</Table>

            </>
          )}
        </Modal.Body>
      </Modal>

 {/* Student Application Form */}

<Modal
  show={showAppFormModal}
  onHide={() => setShowAppFormModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Student Application Form</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {!appFormData ? (
      <div>Loading application form...</div>
    ) : appFormData.error ? (
      <Alert variant="danger">{appFormData.error}</Alert>
    ) : (
      <div>
        {/* Render all form fields */}
     <div id="printableAppForm">
  <Table bordered>
    <tbody>
      {/* 1. PHOTO FIRST */}
      {"photo" in appFormData && appFormData.photo && (
        <tr key="photo">
          <td><b>Photo</b></td>
          <td>
            <img
              src={appFormData.photo}
              alt="Photo"
              style={{ maxWidth: 150, maxHeight: 150, borderRadius: 12, border: "1px solid #ddd" }}
            />
          </td>
        </tr>
      )}

      {/* 2. REST OF FIELDS (except doc checklist, declaration, photo) */}
      {Object.entries(appFormData).map(([key, value]) => {
        if (
          ["_id", "__v", "createdAt", "updatedAt", "photo", "documentChecklist", "declarationAgreed"].includes(key)
        )
          return null;
        if (Array.isArray(value)) {
          return (
            <tr key={key}>
              <td><b>{key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}</b></td>
              <td>
                <ul>
                  {value.map((item, idx) => (
                    <li key={idx}>
                      {typeof item === "object"
                        ? Object.entries(item).map(([k, v]) =>
                            <div key={k}><b>{k.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}:</b> {String(v)}</div>
                          )
                        : String(item)}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          );
        }
        if (typeof value === "object" && value !== null) {
          return (
            <tr key={key}>
              <td><b>{key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}</b></td>
              <td>
                {Object.entries(value).map(([k, v]) =>
                  <div key={k}><b>{k.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}:</b> {String(v)}</div>
                )}
              </td>
            </tr>
          );
        }
        return (
          <tr key={key}>
            <td><b>{key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}</b></td>
            <td>{String(value)}</td>
          </tr>
        );
      })}

      {/* 3. DOCUMENT CHECKLIST NEAR BOTTOM */}
      {"documentChecklist" in appFormData && (
        <tr key="documentChecklist">
          <td><b>Document Checklist</b></td>
          <td>
            {Object.entries(appFormData.documentChecklist).map(([k, v]) =>
              <span key={k} style={{ marginRight: 14 }}><b>{k}:</b> {String(v)}</span>
            )}
          </td>
        </tr>
      )}

      {/* 4. DECLARATION AGREED LAST */}
      {"declarationAgreed" in appFormData && (
        <tr key="declarationAgreed">
          <td><b>Declaration Agreed</b></td>
          <td>{String(appFormData.declarationAgreed)}</td>
        </tr>
      )}
    </tbody>
  </Table>
</div>




        <Button
  variant="secondary"
  onClick={() => {
    const printContents = document.getElementById("printableAppForm").innerHTML;
    const printWindow = window.open('', '', 'height=600,width=900');
    printWindow.document.write('<html><head><title>Student Application Form</title>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 700); // wait for images/fonts to load
  }}
>
  Print / Save as PDF
</Button>

      </div>
    )}
  </Modal.Body>
</Modal>




      {/* Institute Profile Modal */}
      <Modal show={showInstituteModal} onHide={() => setShowInstituteModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Institute Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedInstitute && (
            <>
              <ListGroup>
                <ListGroup.Item><b>Name:</b> {selectedInstitute.name}</ListGroup.Item>
                <ListGroup.Item><b>Email:</b> {selectedInstitute.email}</ListGroup.Item>
                {selectedInstitute.contactPerson && <ListGroup.Item><b>Contact Person:</b> {selectedInstitute.contactPerson}</ListGroup.Item>}
                {selectedInstitute.phone && <ListGroup.Item><b>Phone:</b> {selectedInstitute.phone}</ListGroup.Item>}
                {selectedInstitute.website && <ListGroup.Item><b>Website:</b> {selectedInstitute.website}</ListGroup.Item>}
                {selectedInstitute.address && <ListGroup.Item><b>Address:</b> {selectedInstitute.address}</ListGroup.Item>}
                <ListGroup.Item>
                  <b>Departments & Courses:</b>
                  {selectedInstitute.departments && selectedInstitute.departments.length > 0 ? (
                    <ul>
                      {selectedInstitute.departments.map((dept, idx) => (
                        <li key={idx}>
                          <b>{dept.name}</b>
                          <ul>
                            {dept.courses.map((c, i) => <li key={i}>{c}</li>)}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-muted"> No departments listed.</span>
                  )}
                </ListGroup.Item>
              </ListGroup>
              <hr />
              <h5>Applications Received:</h5>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Student</th>
                    <th>Email</th>
                    <th>Department</th>
                    <th>Course</th>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {applications.filter(app => app.instituteEmail === selectedInstitute.email).map((app, i) => (
                    <tr key={i}>
                      <td>{app.studentName}</td>
                      <td>{app.studentEmail}</td>
                      <td>{app.department}</td>
                      <td>{app.course}</td>
                      <td>{app.date}</td>
                      <td>{app.status}</td>
                    </tr>
                  ))}
                  {applications.filter(app => app.instituteEmail === selectedInstitute.email).length === 0 &&
                    <tr><td colSpan={6} className="text-center text-muted">No applications</td></tr>
                  }
                </tbody>
              </Table>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* Change Password Modal */}
      <Modal show={showChangePassModal} onHide={() => setShowChangePassModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
              minLength={4}
            />
          </Form.Group>
          {changePassError && <Alert variant="danger">{changePassError}</Alert>}
          {changePassSuccess && <Alert variant="success">{changePassSuccess}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowChangePassModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleChangePassword}>Change</Button>
        </Modal.Footer>
      </Modal>

      {/* Message Thread Modal */}
      <Modal show={showMsgModal} onHide={() => setShowMsgModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Conversation with {msgTarget?.name || '-'} ({msgTarget?.type})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 400, overflowY: 'auto' }}>
          {msgAlert && <Alert variant="info">{msgAlert}</Alert>}
          <ListGroup>
            {msgThread.length === 0 && (
              <ListGroup.Item className="text-muted">No messages yet.</ListGroup.Item>
            )}
            {msgThread.filter(msg => msg && typeof msg === 'object' && msg.from && msg.text)
  .map((msg, idx) => (
    <ListGroup.Item key={idx} className={msg.from === "admin" ? "bg-light" : ""}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>
          <b>{msg.from === "admin"
            ? "Admin"
            : msgTarget?.type === "student"
              ? "Student"
              : "Institute"
          }:</b> {msg.text}
          <div className="text-secondary" style={{ fontSize: 12 }}>{msg.date || ''}</div>
        </span>
      
      </div>
    </ListGroup.Item>
))}

          </ListGroup>
          {/* Reply Box */}
          <Form.Group className="mt-3">
            <Form.Control
              as="textarea"
              rows={2}
              value={msgText}
              placeholder="Type your reply..."
              onChange={e => setMsgText(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMsgModal(false)}>Close</Button>
         <Button variant="primary" onClick={handleSendAdminMsg} disabled={!msgText.trim()}>Send</Button>


        </Modal.Footer>
      </Modal>
    <Modal
  show={showReceiptModal}
  onHide={() => setShowReceiptModal(false)}
  size="md"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Receipt Preview</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ textAlign: "center", minHeight: 250 }}>
    {previewReceipt ? (
      previewReceipt.type && previewReceipt.type.startsWith("image/") ? (
        <img
          src={
            previewReceipt.url && previewReceipt.url.startsWith("/uploads")
              ? `${API_BASE}${previewReceipt.url}`
              : previewReceipt.url
          }
          alt="Receipt"
          style={{ maxWidth: "100%", maxHeight: 380, borderRadius: 8, border: "1px solid #ddd" }}
        />
      ) : previewReceipt.type === "application/pdf" ? (
        <iframe
          src={
            previewReceipt.url && previewReceipt.url.startsWith("/uploads")
              ? `${API_BASE}${previewReceipt.url}`
              : previewReceipt.url
          }
          title="Receipt PDF"
          style={{ width: "100%", height: 380, border: "none", borderRadius: 8 }}
        />
      ) : (
        <a
          href={
            previewReceipt.url && previewReceipt.url.startsWith("/uploads")
              ? `${API_BASE}${previewReceipt.url}`
              : previewReceipt.url
          }
          download={previewReceipt.name}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download {previewReceipt.name}
        </a>
      )
    ) : (
      <span>No receipt to display.</span>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowReceiptModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>




{/*queries render */}

{tab === 'queries' && sectionCard(
  "Student Queries",
  <>
    {/* Controls row: date filter, export, refresh */}
    <div style={{ display: "flex", gap: "1rem", alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
      <Form.Group controlId="queryDateFilter" style={{ marginBottom: 0 }}>
        <Form.Label style={{ marginBottom: 0 }}>Filter by Date</Form.Label>
        <Form.Control
          type="date"
          value={queryDateFilter}
          onChange={e => setQueryDateFilter(e.target.value)}
          style={{ maxWidth: 180, marginTop: 0 }}
        />
      </Form.Group>

      <Button
        variant="outline-success"
        onClick={exportQueriesToCSV}
        style={{ height: 38, marginTop: 22 }}
      >
        Export to CSV
      </Button>

      {/* Optional manual refresh (respects the 1-hour rule via lastQueriesFetched) */}
      <Button
        size="sm"
        variant="info"
        onClick={() => setLastQueriesFetched(0)}
        style={{ marginTop: 22 }}
      >
        Refresh
      </Button>
    </div>

    {queriesLoading && <div>Loading queries.</div>}
    {queriesError && <Alert variant="danger">{queriesError}</Alert>}

    {!queriesLoading && getFilteredQueries().length === 0 && (
      <div className="text-muted">
        {queryDateFilter ? "No queries found for selected date." : "No queries received yet."}
      </div>
    )}

    {!queriesLoading && getFilteredQueries().length > 0 && (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Student Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Course</th>
            <th>University</th>
            <th>Date</th>
            <th>Open</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {getFilteredQueries().map((q) => (
            <tr key={q._id}>
              <td>{q.studentName}</td>
              <td>{q.studentPhone}</td>
              <td>{q.studentEmail}</td>
              <td>{q.courseName}</td>
              <td>{q.universityName}</td>
              <td>{new Date(q.date).toLocaleString()}</td>
              <td>
                <Button
                  size="sm"
                  onClick={() => setSelectedQuery(q)}
                  variant={readQueryIds.includes(q._id) ? "secondary" : "info"}
                >
                  View
                </Button>
              </td>
              <td>
                {(currentAdmin?.isMaster || currentAdmin?.permissions?.deleteQueries) ? (
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={async () => {
                      if (!window.confirm("Are you sure you want to delete this query?")) return;
                      try {
                        const token = localStorage.getItem('authToken');
                        await fetch(`/api/admin/query/${q._id}`, {
                          method: "DELETE",
                          headers: { 'Authorization': `Bearer ${token}` }
                        });
                        setQueries(qs => qs.filter(query => query._id !== q._id));
                        setSelectedQuery(sq => (sq && sq._id === q._id ? null : sq));
                      } catch {
                        alert("Could not delete query. Try again.");
                      }
                    }}
                  >
                    Delete
                  </Button>
                ) : (
                  <Button size="sm" variant="danger" disabled title="No permission">Delete</Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}

    {/* Query Detail View */}
    {selectedQuery && (
      <div style={{ marginTop: 20, border: "1px solid #eee", borderRadius: 8, padding: 16 }}>
        <h5>Query Details</h5>
        <p><b>Student Name:</b> {selectedQuery.studentName}</p>
        <p><b>Phone:</b> {selectedQuery.studentPhone}</p>
        <p><b>Email:</b> {selectedQuery.studentEmail}</p>
        <p><b>Course:</b> {selectedQuery.courseName}</p>
        <p><b>University:</b> {selectedQuery.universityName}</p>
        <p><b>Message:</b> {selectedQuery.message || <span className="text-muted">(none)</span>}</p>
        <p><b>Date:</b> {new Date(selectedQuery.date).toLocaleString()}</p>
        <Button variant="secondary" onClick={() => setSelectedQuery(null)}>Close</Button>
      </div>
    )}
  </>
)}





{/*Acadmeies/consultants Modal*/}

<Modal show={showAcademyModal} onHide={() => setShowAcademyModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Add Academy/Consultant</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          value={newAcademy.name}
          onChange={e => setNewAcademy({ ...newAcademy, name: e.target.value })}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Address</Form.Label>
        <Form.Control
          value={newAcademy.address}
          onChange={e => setNewAcademy({ ...newAcademy, address: e.target.value })}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>City</Form.Label>
        <Form.Control
          value={newAcademy.city}
          onChange={e => setNewAcademy({ ...newAcademy, city: e.target.value })}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Contact Person</Form.Label>
        <Form.Control
          value={newAcademy.contactPerson}
          onChange={e => setNewAcademy({ ...newAcademy, contactPerson: e.target.value })}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Phone</Form.Label>
        <Form.Control
          value={newAcademy.phone}
          onChange={e => setNewAcademy({ ...newAcademy, phone: e.target.value })}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Email</Form.Label>
        <Form.Control
          value={newAcademy.email}
          onChange={e => setNewAcademy({ ...newAcademy, email: e.target.value })}
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowAcademyModal(false)}>
      Cancel
    </Button>
    <Button variant="primary" onClick={handleAddAcademy}>
      Add
    </Button>
  </Modal.Footer>
</Modal>










{/* Offer Accepted Proof Modal*/}

<Modal
  show={showOfferProofModal}
  onHide={() => setShowOfferProofModal(false)}
  size="md"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Offer Acceptance Proof</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ textAlign: "center", minHeight: 200 }}>
    {offerProofDoc ? (
      offerProofDoc.type && offerProofDoc.type.startsWith("image/") ? (
        <img
          src={getDocDownloadUrl(offerProofDoc)}
          alt="Offer Acceptance Proof"
          style={{ maxWidth: "100%", maxHeight: 350, borderRadius: 8, border: "1px solid #ddd" }}
        />
      ) : offerProofDoc.type === "application/pdf" ? (
        <iframe
          src={getDocDownloadUrl(offerProofDoc)}
          title="Offer Acceptance Proof PDF"
          style={{ width: "100%", height: 350, border: "none", borderRadius: 8 }}
        />
      ) : (
        <a
          href={getDocDownloadUrl(offerProofDoc)}
          download={offerProofDoc.name}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download {offerProofDoc.name}
        </a>
      )
    ) : (
      <span>No proof document to display.</span>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowOfferProofModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


<Modal
  show={showReferredModal}
  onHide={() => setShowReferredModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>
    Referred By:   {referredByAcademy?.name}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {referredStudents.length > 0 ? (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {referredStudents.map((student, i) => (
            <tr key={i}>
              <td>{student.name}</td>
              <td>{student.email}</td>
              <td>{student.phone}</td>
              <td>
          {student.offerStatus === "Accepted"
            ? <span style={{ color: "#128b30", fontWeight: 600 }}>Accepted</span>
            : <span style={{ color: "#2979ff", fontWeight: 600 }}>Registered</span>
          }
        </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <div className="text-muted text-center">No students referred by this academy yet.</div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowReferredModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>



    </Container>
  );
}

export default AdminDashboard;